import React from 'react'
import { useTranslation } from 'react-i18next';

import * as PR from "../../prime-modules/index";
import getAssets from "../../assets/data/brandingAssets.json"
import { getImageSrc } from '../../utils/reuse';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from 'react-query';
import { setLanguageIntial } from '../../store/language.slice';
import { getlanguageAPI } from '../../services/api';
import DOMPurify from 'dompurify';
import truncate from 'truncate-html';
import { languageList } from '../../utils/localstore';

const truncateHTML = (html, maxLength) => {
  return DOMPurify.sanitize(truncate(html, maxLength, { byWords: true, ellipsis: "..." }));
};

function Faq({navigate, home}) {

    let faq_image = getImageSrc(home?.HOMEN0084, getAssets.home.faq_image)

    const { i18n } = useTranslation();
    const i18Language = i18n.language.split('-')[0]
    const language =  languageList.includes(i18Language) ? i18Language : 'en'
    const lnFromStore = useSelector(state=>state.language);
    const dispatch = useDispatch();
    let {isLoading} = useQuery(['faq-new',language],getlanguageAPI.bind(null,language,"faq-new"),{
        enabled:!lnFromStore[language],
        onSuccess: o => dispatch(setLanguageIntial({k:language,v:o}))
    });
   const faqs = useSelector(state => state.language?.activelang?.faq);

   const list = Object.entries(JSON.parse(faqs?.categories || "{}"))
   .filter(([key, value]) => {
    let list = !!faqs[key] ? JSON.parse(faqs[key]) : undefined
    return !!faqs[key] && value?.status && list?.length !== 0
})
   .map(([key, value]) => ({
     name: value?.name,
     questions: faqs[key] ? JSON.parse(faqs[key]) : [] 
   }));
   let faqData = !isLoading && !!list ? list :[]
   let faq = faqData[0]

   const removeImages = (html) => {
    return html.replace(/<img[^>]*>/g, "");
   };

   const generateSlug = (text) =>
    text ? text.toLowerCase().replace(/[^\w\s]/g, "").replace(/\s+/g, "-") : "";
  return (
    <section id="faq" className="faqs-section">
    <div className="card">
        <div className='text-center'>
            <h2>{home?.HOMEN0059}</h2>
            {/* Removed as per Chandru's instructions. */}
            {/* <p>{labels?.LBLN0203}</p> */}
        </div>
        <div className='grid custom-margin'>
            <div className="col-12 lg:col-6">
                <div className="faq-wrapper">
                {faq?.questions?.length > 0 ? (
    faq?.questions?.slice(0, 4).map((item, index) => (
        <div key={index} className='faq-list'>
            <h3>{item.question}</h3>
            <p style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
                <div dangerouslySetInnerHTML={{ __html: truncateHTML(removeImages(item?.answer), 20) }} />
                <span className="see-more" onClick={navigate.bind(null, `/faq?query=${generateSlug(item?.question)}`)}>
                    see more
                </span>
            </p>
        </div>
    ))
) : (
    // Skeleton loader when FAQs are not yet loaded
    [...Array(4)].map((_, index) => (
        <div key={index} className='faq-list'>
            <h3><PR.Skeleton width="60%" height="30px"  className='my-3' /></h3>
            <p>
                <PR.Skeleton width="100%" height="50px" />
                {/* <PR.Skeleton width="30%" height="15px" style={{ marginTop: '5px' }} /> */}
            </p>
        </div>
    ))
)}
                    <PR.Button onClick={navigate.bind(null, "/faq")} label={home?.HOMEN0060} className="faq-button" />
                </div>
            </div>
            <div className="col-12 lg:col-6 text-center">
                <PR.Image src={faq_image} alt="Faq image" className='faq-image'/>
            </div>
        </div>
    </div>
</section>
  )
}

export default Faq